export default __webpack_public_path__ + "static/media/bg1.7799f821.jpg";